import { API } from "./axios.service"

export class CRMService {
    static async GETNOTES(data: any): Promise<any> {
        return API.get(`/api/v1/note/get`, { params: data });
    }

    static async GET_CUSTOMERS(data:any): Promise<any>{
        return API.get(`/api/v1/customer/get`, {params: data}); 
    }

    static async CREATE_CUSTOMERS(data:any): Promise<any>{
        return API.post(`/api/v1/customer/create`, data); 
    }

    // notes api

    static async GET_NOTES(data:any): Promise<any>{
        return API.post(`/api/v1/note/get`, data); 
    }

}